import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';

import {  NotMobile } from 'utils';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    width: 345,
    height: 300,
  },
  media: {
    height: 140,
  },
});

function ToText(node) {
    let tag = document.createElement("div");
    tag.innerHTML = node;
    node = tag.innerText;
    return node;
  }

function ShortenText(text, startingPoint, maxLength) {
    return text.length > maxLength ? text.slice(startingPoint, maxLength) : text;
}


export default function MediumCard({
    blank,
    content,
    link,
    thumbnail,
    title
}) {

    const classes = useStyles();

    if (blank) {
        return (
            <>
                <NotMobile>
                    <Card className={classes.root} style={{ visibility: "hidden"}}>
                        <CardActionArea style={{ height: "100%" }}>
                        </CardActionArea>
                    </Card>
                </NotMobile>
            </>
        )
    }
    
    return (
        <a href={link} target="_blank" style={{ textDecoration: "none" }}>
            <Card className={classes.root}>
            <CardActionArea style={{ height: "100%" }}>
                <CardMedia
                className={classes.media}
                image={thumbnail}
                title="Contemplative Reptile"
                />
                <CardContent style={{ height: "100%" }}>
                <Typography gutterBottom variant="h5" component="h2">
                    {ShortenText(title, 0, 50)}
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                    {ShortenText(ToText(content), 0, 120) + '...'}
                </Typography>
                </CardContent>
            </CardActionArea>
            </Card>
        </a>
      );
} 